import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const archiveClasses = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.DISTRIBUTE.ARCHIVE_CLASSES,
    data
  );
};

export default archiveClasses;
